module.exports = __webpack_public_path__ + "img/33-green.afecaaa5.svg";